import React from "react";
import { Container, Message } from "basis";

import isProd from "../../../../utils/isProd";

export const Messages = ({ allowRetry = false, hasError = false }) => (
  <>
    {!isProd() && (
      <Container padding="6 0 0 0">
        <Message severity="warning-or-significant" bg="secondary.lightBlue.t25">
          This shop is currently running in test mode. All transactions are
          simulated and no payments will be processed.
        </Message>
      </Container>
    )}

    {!allowRetry && !hasError && (
      <Container padding="6 0 0 0">
        <Message severity="warning-or-significant" bg="secondary.pink.t30">
          Unfortunately your purchase has been retried too many times. Please
          cancel your order to return to the store.
        </Message>
      </Container>
    )}

    {hasError && (
      <Container padding="6 0 0 0">
        <Message severity="warning-or-significant" bg="secondary.pink.t30">
          Unfortunately there has been an error with this transaction. Please
          cancel your order to return to the store.
        </Message>
      </Container>
    )}
  </>
);
